import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import styled from 'styled-components'
import parse from 'html-react-parser'
import Img from 'gatsby-image'
import { device } from '../components/Breakpoints'
import { Breadcrumb } from '../components/Breadcrumb'
import { colors } from '../components/Colors'
import iconcoracaozinho from '../icons/icon-coracaozinho.svg'
import iconlinguinha from '../icons/icon-linguinha.svg'
import iconolhinho from '../icons/icon-olhinho.svg'
import iconorelhinha from '../icons/icon-orelhinha.svg'
import imgpezinho from '../img/pezinho.png'
import imgoutrosprocedimento from '../img/outros-procedimento.jpg'
import PageHeader from '../components/PageHeader'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'
import CentralAtendimento from '../components/CentralAtendimento'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
`

const GroupContent = styled.section`
  padding: 2em 0;
  h3 {
    color: #8e8fc7;
  }
  .offsetImgEnd2 {
    padding-bottom: 20px;
  }
  .cuidados {
    display: flex;
    align-items: center;
    padding: 20px 20px 40px;
    margin: 20px 0;
    background-color: #ffffff;
    max-height: 244px;
    overflow: hidden;
    box-shadow: 0px 31px 95px -40px rgba(0, 0, 0, 0.75);
    @media ${device.mobileL} {
      flex-wrap: wrap;
      max-height: 100%;
    }
    h3 {
      color: ${colors.lilas};
      position: relative;
      margin: 0;
      font-size: 1em;
      padding: 2em;
      :before {
        position: absolute;
        content: '';
        top: 24px;
        left: 38px;
        border: 1px solid ${colors.lilas};
        width: 5%;
        opacity: 0.5;
        @media ${device.mobileL} {
          left: 22px;
        }
      }
      :after {
        position: absolute;
        content: '';
        bottom: 24px;
        left: 38px;
        border: 1px solid ${colors.lilas};
        width: 5%;
        opacity: 0.5;
        @media ${device.mobileL} {
          left: 22px;
        }
      }
      @media ${device.mobileL} {
        padding: 2em 5px 2em 1em;
      }
    }
    div {
      height: 100%;
      @media ${device.mobileL} {
        order: 1;
        width: 100%;
      }
    }
    img {
      max-height: 250px;
      @media ${device.mobileL} {
        order: 2;
      }
    }
    p {
      color: #707070;
      padding: 0 2em;
      @media ${device.mobileL} {
        padding: 1em;
      }
    }
    .icones {
      display: flex;
      padding: 0 30px;
      align-items: center;
      img {
        @media ${device.mobileL} {
          display: block;
          margin: auto;
        }
      }
      @media ${device.mobileL} {
        padding: 0;
        display: block;
      }
    }
    @media ${device.mobileL} {
      justify-content: center;
    }
  }
  .pezinho {
    overflow: hidden;
    img {
      @media ${device.mobileL} {
        margin: 2em 0 -0.5em;
      }
    }
  }
  .inner {
    display: flex;
    justify-content: space-between;
    div {
      width: 60%;
      padding-top: 40px;
      padding-right: 30px;
      @media ${device.mobileL} {
        width: 100%;
        padding-right: 0px;
      }
    }
    h2 {
      color: #fff8d1;
    }
    img {
      max-height: 250px;
      @media ${device.mobileL} {
        padding: 0;
        width: 100%;
      }
    }
    @media ${device.mobileL} {
      display: block;
    }
  }
  a {
    color: #ffffff;
    font-weight: bold;
  }
  .procedimentos {
    display: flex;
    justify-content: space-between;
    div {
      width: 55%;
      padding-right: 50px;
      @media ${device.mobileL} {
        width: 100%;
        padding-right: 0px;
      }
    }
    img {
      max-width: 100%;
      @media ${device.mobileL} {
        margin-top: 2em;
        max-width: 137%;
      }
    }
    @media ${device.mobileL} {
      display: block;
    }
  }
  :nth-of-type(2) {
    background: ${colors.lilasGradiente};
    color: #ffffff;
  }
  :nth-of-type(3) {
    padding: 0em;
    background: ${colors.verdeGradiente};
    color: #ffffff;
    @media ${device.mobileL} {
      padding: 0 2em;
    }
  }
  :nth-of-type(4) {
    h2 {
      color: #fa7373;
    }
  }
  @media ${device.mobileL} {
    padding: 2em;
    p,
    h3 {
      text-align: left;
    }
  }
`

export const ProcedimentosRealizadosTemplate = ({
  title,
  content,
  slug,
  image,
  color,
  area = 'Centros e Serviços',
  sessoes,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '#', title: area, icon: true },
    { id: 3, link: slug, title },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />

        <PageHeader
          title={title}
          content={content}
          image={image}
          color={color}
          txtColor="cinza"
          height="255px"
          right="-65px"
          bottom="-54px"
          imgWidth="63%"
          titleWidth="580px"
          overflow="visible"
          imgInner
          mobileTop="-5%"
        />
        <GroupContent>
          <div className="center">
            {parse(sessoes[0].texto)}
            <div className="cuidados">
              <div>
                <div className="icones">
                  <img src={iconolhinho} alt="Ultrassom" />
                  <h3>{parse(sessoes[1].tituloDaSessao)}</h3>
                </div>
                {parse(sessoes[1].texto)}
              </div>
            </div>
            <div className="cuidados">
              <div>
                <div className="icones">
                  <img src={iconorelhinha} alt="Ultrassom" />
                  <h3>{parse(sessoes[2].tituloDaSessao)}</h3>
                </div>
                {parse(sessoes[2].texto)}
              </div>
            </div>
            <div className="cuidados">
              <div>
                <div className="icones">
                  <img src={iconcoracaozinho} alt="Ultrassom" />
                  <h3>{parse(sessoes[3].tituloDaSessao)}</h3>
                </div>
                {parse(sessoes[3].texto)}
              </div>
            </div>
            <div className="cuidados">
              <div>
                <div className="icones">
                  <img src={iconlinguinha} alt="Ultrassom" />
                  <h3>{parse(sessoes[4].tituloDaSessao)}</h3>
                </div>
                {parse(sessoes[4].texto)}
              </div>
            </div>
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner center pezinho">
            <div>
              <h2>{parse(sessoes[5].tituloDaSessao)}</h2>
              {parse(sessoes[5].texto)}
            </div>
            <img
              src={sessoes[5].imagemDaSessao.sourceUrl}
              alt="Teste do pezinho"
            />
          </div>
        </GroupContent>
        <GroupContent>
          <div className="center">
            <h2>{parse(sessoes[6].tituloDaSessao)}</h2>
          </div>
          <div className="procedimentos center">
            <div>{parse(sessoes[6].texto)}</div>
            {sessoes[6].imagemDaSessao.localFile ? (
              <Img
                fluid={
                  sessoes[6].imagemDaSessao.localFile.childImageSharp.fluid
                }
                alt="Passo a passo na maternidade"
                className="offsetImgEnd2"
              />
            ) : (
              <img
                src={sessoes[6].imagemDaSessao.sourceUrl}
                alt="Passo a passo na maternidade"
                className="offsetImgEnd2"
              />
            )}
          </div>
        </GroupContent>
        <CentralAtendimento />
      </Container>
    </>
  )
}

ProcedimentosRealizadosTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const ProcedimentosRealizados = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const { sessaoCustomizada: sessoes } = page.SessoesCustomizadas
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <ProcedimentosRealizadosTemplate
        title={page.title}
        content={page.content}
        image={image}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        sessoes={sessoes}
      />
      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

ProcedimentosRealizados.propTypes = {
  data: PropTypes.object.isRequired,
}

export default ProcedimentosRealizados

export const ProcedimentosRealizadosQuery = graphql`
  query ProcedimentosRealizadosById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      SessoesCustomizadas {
        sessaoCustomizada {
          listaDeItens {
            item
          }
          texto
          tituloDaSessao
          imagemDaSessao {
            sourceUrl
            localFile {
              childImageSharp {
                fluid {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          acordeao {
            titulo
            conteudo
          }
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
